import { ExperiencedServices } from '@/components/home/ExperiencedService';
import { HomeHero } from '@/components/home/hero';
import { QaulityService } from '@/components/home/QualityService';
import TrustedCertified from '@/components/home/TrustedCertified';
import { WhatPeopleSay } from '@/components/home/WhatPeopleSay';
import { WorkingSince } from '@/components/home/WorkingSince';

const Home = () => {
  return (
    <div className="home mt-[11rem] w-full">
      <HomeHero />
      <WorkingSince />
      <QaulityService />
      <TrustedCertified />
      <ExperiencedServices />

      <WhatPeopleSay />
    </div>
  );
};

export default Home;
